import React from 'react';

export default () => (
  <svg viewBox='0 0 32 32' fill='none'>
    <path
      fill='currentColor'
      d='M32 16c0 8.839-7.161 16-16 16-1.652 0-3.239-.252-4.736-.716.652-1.065 1.626-2.807 1.988-4.194.193-.748.993-3.806.993-3.806.523.993 2.045 1.839 3.665 1.839 4.825 0 8.303-4.44 8.303-9.955 0-5.284-4.316-9.239-9.865-9.239-6.903 0-10.574 4.632-10.574 9.684 0 2.348 1.252 5.27 3.245 6.2.304.142.465.077.536-.213.051-.22.322-1.31.445-1.813a.479.479 0 00-.11-.458c-.651-.806-1.18-2.277-1.18-3.652 0-3.529 2.67-6.942 7.225-6.942 3.93 0 6.684 2.678 6.684 6.51 0 4.33-2.187 7.33-5.032 7.33-1.568 0-2.748-1.298-2.368-2.891.452-1.903 1.323-3.955 1.323-5.33 0-1.225-.658-2.25-2.026-2.25-1.606 0-2.897 1.657-2.897 3.883 0 1.42.478 2.374.478 2.374s-1.58 6.697-1.871 7.949c-.323 1.38-.194 3.329-.058 4.593C4.219 28.574 0 22.781 0 16 0 7.161 7.161 0 16 0s16 7.161 16 16z'
    />
  </svg>
);
